"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ECustomerTypeSelection = void 0;
let ECustomerTypeSelection = exports.ECustomerTypeSelection = /*#__PURE__*/function (ECustomerTypeSelection) {
  ECustomerTypeSelection["Myself"] = "Myself";
  ECustomerTypeSelection["ExistingCustomer"] = "ExistingCustomer";
  ECustomerTypeSelection["NewCustomer"] = "NewCustomer";
  return ECustomerTypeSelection;
}({});
